import React from 'react';
import ReactDOM from 'react-dom';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import registerServiceWorker from './registerServiceWorker';
import Amplify from 'aws-amplify';
import ErrorBoundary from './utils/logger';

import Root from './Root';
import config from './config';
import './index.css';

import rootReducer from './redux/reducers';
import { configureStore } from './utils/redux';

const history = createBrowserHistory();
const store = configureStore(connectRouter(history)(rootReducer), {}, routerMiddleware(history));

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
});

ReactDOM.render(
  <ErrorBoundary>
    <Root store={store} history={history} />,
  </ErrorBoundary>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js